.button-load-more-notes-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.button-load-more-notes {
  appearance: none;
  background-color: var(--palette-accent-primary);
  border: 0;
  border-radius: 0;
  color: var(--palette-accent-primary-contra);
  cursor: pointer;
  font: use-font-secondary("700 14px/20px");
  padding: 7px 20px;
  text-transform: uppercase;

  &:focus {
    outline: 1px solid var(--palette-accent-primary-contra);
  }
}